import { useState, useEffect, type JSX } from 'react';
import { useWalkthroughState } from '../../hooks/useWalkthroughState';
import { WelcomeWalkthroughStep } from './WelcomeWalkthroughStep';

/**
 * Manages the welcome walkthrough display
 * Shows welcome walkthrough if not completed
 */
export function WalkthroughManager(): JSX.Element | null {
  console.log('WalkthroughManager component function called');
  const { 
    status, 
    isLoading, 
    markWalkthroughCompleted 
  } = useWalkthroughState();
  
  const [showWelcome, setShowWelcome] = useState(false);
  
  useEffect(() => {
    if (!isLoading) {
      console.log('Determining whether to show walkthrough:', {
        status,
        isLoading
      });
      
      // Show welcome walkthrough if not completed
      if (status !== 'completed') {
        console.log('Showing welcome walkthrough - status is not completed');
        setShowWelcome(true);
      } else {
        console.log('Walkthrough already completed - not showing');
      }
    }
  }, [isLoading, status]);
  
  // Handle welcome walkthrough completion
  const handleWelcomeClosed = async () => {
    console.log('Welcome walkthrough closed by user');
    setShowWelcome(false);
    
    try {
      await markWalkthroughCompleted();
      console.log('Walkthrough marked as completed');
      
      // Force a full page reload to /reflection to refresh subscription state
      console.log('Reloading page to /reflection after walkthrough completion');
      window.location.href = '/reflection';
    } catch (error) {
      console.error('Error handling welcome walkthrough closure:', error);
    }
  };
  
  if (isLoading) {
    return null;
  }
  
  return (
    <>
      {showWelcome && (
        <WelcomeWalkthroughStep 
          opened={showWelcome} 
          onClose={handleWelcomeClosed} 
        />
      )}
    </>
  );
}